/**
 * DevPage
 * This is DevPage API contract
 *
 * OpenAPI spec version: 1.1.0
 * Contact: apiteam@swagger.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorResponse } from '../model/errorResponse';
import { NotificationsConfig } from '../model/notificationsConfig';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class NotificationConfigsService {

    protected basePath = 'http://localhost:8090';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param notificationsConfig 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createNotificationConfig(notificationsConfig: NotificationsConfig, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public createNotificationConfig(notificationsConfig: NotificationsConfig, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public createNotificationConfig(notificationsConfig: NotificationsConfig, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public createNotificationConfig(notificationsConfig: NotificationsConfig, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (notificationsConfig === null || notificationsConfig === undefined) {
            throw new Error('Required parameter notificationsConfig was null or undefined when calling createNotificationConfig.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/notifications/configs`,
            notificationsConfig,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getNotificationsConfig(observe?: 'body', reportProgress?: boolean): Observable<NotificationsConfig>;
    public getNotificationsConfig(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NotificationsConfig>>;
    public getNotificationsConfig(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NotificationsConfig>>;
    public getNotificationsConfig(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<NotificationsConfig>(`${this.configuration.basePath}/notifications/configs`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param userId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserNotificationConfig(userId: string, observe?: 'body', reportProgress?: boolean): Observable<NotificationsConfig>;
    public getUserNotificationConfig(userId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NotificationsConfig>>;
    public getUserNotificationConfig(userId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NotificationsConfig>>;
    public getUserNotificationConfig(userId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getUserNotificationConfig.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<NotificationsConfig>(`${this.configuration.basePath}/user/${encodeURIComponent(String(userId))}/notifications/configs`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param notificationsConfig 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateNotificationConfig(notificationsConfig: NotificationsConfig, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateNotificationConfig(notificationsConfig: NotificationsConfig, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateNotificationConfig(notificationsConfig: NotificationsConfig, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateNotificationConfig(notificationsConfig: NotificationsConfig, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (notificationsConfig === null || notificationsConfig === undefined) {
            throw new Error('Required parameter notificationsConfig was null or undefined when calling updateNotificationConfig.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/notifications/configs`,
            notificationsConfig,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param userId 
     * @param notificationsConfig 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateUserNotificationConfig(userId: string, notificationsConfig: NotificationsConfig, observe?: 'body', reportProgress?: boolean): Observable<NotificationsConfig>;
    public updateUserNotificationConfig(userId: string, notificationsConfig: NotificationsConfig, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NotificationsConfig>>;
    public updateUserNotificationConfig(userId: string, notificationsConfig: NotificationsConfig, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NotificationsConfig>>;
    public updateUserNotificationConfig(userId: string, notificationsConfig: NotificationsConfig, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling updateUserNotificationConfig.');
        }
        if (notificationsConfig === null || notificationsConfig === undefined) {
            throw new Error('Required parameter notificationsConfig was null or undefined when calling updateUserNotificationConfig.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<NotificationsConfig>(`${this.configuration.basePath}/user/${encodeURIComponent(String(userId))}/notifications/configs`,
            notificationsConfig,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
